module.exports = __webpack_public_path__ + "static/media/murat.a326769e.jpg";